import { ref, watch, onScopeDispose, type Ref } from 'vue';

const DEFAULT_DELAY_MS = 400;

// Trailing-edge debounce of a reactive source: the returned ref only takes the
// latest value once the source has been quiet for `delayMs`. No lodash/vueuse
// in the bundle, so this is the shared implementation.
export function useDebouncedRef<T>(source: Ref<T>, delayMs = DEFAULT_DELAY_MS): Ref<T> {
  const debounced = ref(source.value) as Ref<T>;
  let timer: ReturnType<typeof setTimeout> | undefined;

  watch(source, (value) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      debounced.value = value;
    }, delayMs);
  });

  onScopeDispose(() => {
    if (timer) clearTimeout(timer);
  });

  return debounced;
}
